import React from "react";

import Backdrop from "@mui/material/Backdrop";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";

function Loader() {
  return (
    <Backdrop open={true} sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <Box sx={{ width: "80%" }}>
        <LinearProgress color="warning" />
      </Box>
    </Backdrop>
  );
}

export default Loader;
